<template>
  <v-card style="width: 100%" max-width="500" class="pa-4">
    <v-form>
      <v-card-title class="title font-weight-regular justify-center">
        <span>Войти в систему</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-alert v-if="$store.getters['auth/status'] == 'error'" color="red darken-1" dark>
            {{ $t($store.getters["auth/error"]) }}
          </v-alert>
          <a-form-model v-model="data" :model="model" :errors="errors" @validate="validate($event)" @mutate="onMutate($event)" />
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-btn type="submit" color="primary" @click.prevent="submit()">
          {{ $t("Login") }}
        </v-btn>
        <!-- <v-btn color="primary" :to="{ name: 'registration' }">
          {{ $t("Registration") }}
        </v-btn> -->
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import { validate, validators, fillForm } from "./../../components/mixings";

export default {
  mixins: [validate, validators, fillForm],
  data() {
    return {
      useMask: true,
      data: {},
      model: [
        {
          name: "login",
          title: "Логин",
          validator: ["req"],
          type: "stringmask",
          mask: "^[0-9]*.?,?[0-9]*$",
          format: !true,
        },
        {
          name: "password",
          title: "Пароль",
          type: "password",
          validator: ["req"],
        },
      ],
      errors: {},
    };
  },
  methods: {
    onMutate(e) {
      if (e.event == "maskDisable") this.useMask = false;
    },
    async submit() {
      let login = this.data.login;
      let data = Object.assign({}, this.data);
      if (login) data.login = data.login.replace(/\s+/g, "");
      if (this.useMask) data.login = data.login.replace(/\D+/g, "");
      if (await this.validateAll(data)) {
        await this.login(data);
      }
    },
    async login(d) {
      try {
        await this.$root.login({
          login: d.login,
          password: d.password,
        });
        this.$router.push("/");
      } catch (error) {
        this.error = error;
      }
    },
  },
};
</script>
